import * as React from 'react';

import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {NewsletterSortType, CampaignStatus} from 'nutshell-graphql-types';
import type {
    GetNewsletters as GetNewslettersQuery,
    GetNewslettersVariables as GetNewslettersQueryVariables,
    NewsletterStubFragment as Newsletter,
} from 'nutshell-graphql-types';

import {getNewsletterListQueryVariables} from '../helpers';

import GET_NEWSLETTERS from './graphql/queries/get-newsletters.graphql';

type Props = {
    isArchived: boolean;
    sortOrder: NewsletterSortType;
    searchQuery?: string;
    creatorUserId?: string;
    lastUpdatedTime?: string | null | undefined;
    statuses?: CampaignStatus[];
    children: (arg1: {
        newsletters: Newsletter[];
        isLoading: boolean;
        error: string | null | undefined;
    }) => React.ReactElement;
};

export function NewsletterListQuery(props: Props) {
    const variables = getNewsletterListQueryVariables(
        props.isArchived,
        props.sortOrder,
        props.searchQuery,
        props.creatorUserId,
        props.lastUpdatedTime,
        props.statuses
    );

    const {
        data,
        error,
        loading: isLoading,
    } = useQuery<GetNewslettersQuery, GetNewslettersQueryVariables>(GET_NEWSLETTERS, {
        variables: variables,
        fetchPolicy: 'cache-and-network',
        notifyOnNetworkStatusChange: true,
    });

    const newslettersData = data ? data.newsletters : null;

    const newsletters = newslettersData
        ? newslettersData.edges.map((audience) => {
              return audience.node;
          })
        : [];

    return props.children({
        newsletters,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        isLoading,
    });
}
